<template>
  <div>

    <ImageView v-if="entity.image" :src="entity.image" :desc="entity.imageDesc"></ImageView>

    <pinyin :text="previewSubject" :pinyin="previewSubjectPinyin" v-if="entity.subjectPinyin"></pinyin>
    <div v-else v-html="previewSubject" style="white-space:pre-wrap;"></div>

    <div class="exr-children exr-xzt">
      <div class="exr-child-view" v-for="(child, index) in entity.children" :key="index">
        <div class="number">{{index+1}})</div>
        <div class="items flex-row flex-wrap">
          <div v-for="(item, key) in child.items" :key="key" :class="{'flex-row align-items-center': true, answered: key === child.answer}">
            <div>
              {{key + 1}}. &nbsp;
            </div>
            <pinyin :text="item.text" :pinyin="item.pinyin" v-if="item.pinyin"></pinyin>
            <div v-else>
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageView from './../../ImageView'
import pinyin from './../../PinyinPreview'

export default {
  name: 'XztView',
  components: { ImageView, pinyin },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  computed: {
    realSubject () {
      if (!this.entity || !this.entity.subject) return ''
      return this.entity.subject
    },
    realSubjectPinyin () {
      if (!this.entity || !this.entity.subject) return ''
      return this.entity.subjectPinyin
    },
    previewSubject () {
      let index = 0
      return this.realSubject.replace(/[_＿]{2,}/g, (m) => {
        return `<blank>${++index}</blank>`
      })
    },
    previewSubjectPinyin () {
      return this.realSubjectPinyin.replace(/[_＿]{2,}/g, '')
    }
  }
}
</script>

<style lang="scss">
.exr-child-view{
  margin-top: 5px;
  position: relative;
  padding-left: 20px;
  .number {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -12px;
    color: #409EFF;
  }
}
.exr-theme-line.exr-dwtk{
  .exr-content>div{
    flex: 1;
  }
}
</style>